import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { AddJudgeForm } from './AddJudgeForm';

const STYLE = { estricto: 'Estricto', formalista: 'Formalista', garantista: 'Garantista' };

// Compact card for a first-instance court: type, judges (with Fidem style) and quick add
export const FirstInstanceCourt = ({ c, onChanged }) => {
  const [adding, setAdding] = useState(false);
  return (
    <div data-testid={`court-${c.slug}`} className="rounded-xl border border-slate-800 bg-slate-900/40 p-3">
      <div className="flex items-start gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-white">{c.name}</p>
          <p className="text-[10px] text-slate-500">{c.tipo_label} · jurisdicción {c.corte_name?.replace('Corte de Apelaciones de ', 'C.A. ')}</p>
        </div>
        <button data-testid={`court-add-judge-btn-${c.slug}`} onClick={() => setAdding((v) => !v)} aria-label="Agregar juez" className="rounded-full border border-slate-700 p-1 text-slate-400 transition-colors hover:border-amber-500 hover:text-amber-300"><Plus className="h-3 w-3" /></button>
      </div>
      {c.members.length > 0 ? (
        <div className="mt-2 flex flex-wrap gap-1">
          {c.members.map((p) => (
            <Link key={p.id} to={`/jueces/${p.id}`} data-testid={`court-member-${p.id}`} className="rounded-full border border-slate-700 px-2 py-0.5 text-[11px] text-slate-200 transition-colors hover:border-amber-500">
              {p.name}{p.strategy_profile?.estilo && <span className="ml-1 text-amber-300">· {STYLE[p.strategy_profile.estilo]}</span>}
            </Link>
          ))}
        </div>
      ) : <p className="mt-1 text-[10px] text-slate-600">Nómina no publicada en abierto por el PJUD · agrégala y Fidem la analiza</p>}
      {adding && <AddJudgeForm slug={c.slug} onAdded={() => { setAdding(false); onChanged(); }} />}
    </div>
  );
};
